export { default as CustomerPreferences } from './CustomerPreferences';
export { default as ProductStrategy } from './ProductStrategy';
export { default as MachineOptions } from './MachineOptions';
export { default as DistributionCenters } from './DistributionCenters';
export { default as ShareBuyback } from './ShareBuyback';
export { default as NewMetricROE } from './NewMetricROE';
export { default as NewMetricROA } from './NewMetricROA';
export { default as NewMetricEPS } from './NewMetricEPS';
export { default as ConductResearch } from './ConductResearch';


// WEBPACK FOOTER //
// ./src/components/onboarding/what-to-expect/index.js